import { render, staticRenderFns } from "./GSZC.vue?vue&type=template&id=9bc674d8&scoped=true&"
import script from "./GSZC.vue?vue&type=script&lang=js&"
export * from "./GSZC.vue?vue&type=script&lang=js&"
import style0 from "./GSZC.vue?vue&type=style&index=0&id=9bc674d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc674d8",
  null
  
)

export default component.exports